import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3aac7dec&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3aac7dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aac7dec",
  null
  
)

export default component.exports